import { useState } from "react";

import { AppsList } from "./appsList";
import { ServerList } from "./serverList";

export function AppRegistry(props) {
    const [whichView, setWhichView] = useState("apps");
    
    const getList = () => {
        if (whichView === "apps") {
            return (<AppsList />);
        }
        return (<ServerList />);
    };
    
    return (
        <div>
            <div className="search-filter">
                filter
            </div>
            <div>Select a list -------- <span onClick={() => setWhichView("apps")}>Apps</span> | <span onClick={() => setWhichView("servers")}>Servers</span></div>
            {getList()}
        </div>
    );
}
